<template>
	<div>
		<!-- logo 时间 -->
		<q-head></q-head>
		<!-- banner -->
		<qBanner></qBanner>
		
		
	
		
		<div class="read">
			<div class="read-hd">
				<q-title title="门诊缴费" time="86"></q-title>
				<q-step :step="4"></q-step>
			</div>
			
			<div class="user-info-row fcc">
				<div>
					<span>姓名：</span>
					<b>张三</b>
				</div>
				<div>
					<span>性别：</span>
					<b>男</b>
				</div>
				<div>
					<span>门诊号码：</span>
					<b>9527</b>
				</div>
				
				
			</div>
			
			<div class="sf-list-data">
				<table border="0" cellspacing="0" cellpadding="0"  width="100%">
					<tr>
						<th>收费项目</th>
						<th>开单科室</th>
						<th>开单医生</th>
						<th>开单时间</th>
						<th>金额</th>
						<th>操作</th>
					</tr>
					<tr v-for="item in 5">
						<td>西药方</td>
						<td>内科</td>
						<td>张三</td>
						<td>2021-12-04 03:44:21</td>
						<td>
							<b class="red">100</b>
						</td>
						<td>
							<a class="btn-look" @click="look1">
								查看详情
							</a>
						</td>
					</tr>
					<tr v-for="item in 5">
						<td>处药方</td>
						<td>内科</td>
						<td>张三</td>
						<td>2021-12-04 03:44:21</td>
						<td>
							<b class="red">100</b>
						</td>
						<td>
							<a class="btn-look" @click="look2">
								查看详情
							</a>
						</td>
					</tr>
				</table>
			</div>
			
			
			
			
			<div class="fcc">
				<div class="total-price">
					<span>总金额</span>
					<b>40.79</b>
					<span>元</span>
				</div>
				<div class="list-page fcc">
					<a>上一页</a>
					<span>第</span>
					<span>1/15</span>
					<span>页</span>
					<a>下一页</a>
				</div>
			</div>
			
			
			<div class="foot-buttons fc-bet">
				<a href="/" class="btn-home fcc">
					<img src="../../assets/icon/icon-home.png" >
					<span>首页</span>
				</a>
				<a class="btn-blue fcc" @click="openUrl('/self-pay')">
					<span>自费结算</span>
				</a>
				<a class="btn-orange fcc" @click="useYibao">
					<span>医保结算</span>
				</a>
				<a class="btn-return fcc" @click="returnStep()">
					<img src="../../assets/icon/icon-return.png" >
					<span>返回</span>
				</a>
			</div>
		
		</div>
		
		
		
		<!-- 查看详情弹出框 -->
		
		
		
		
		
		<!-- // 西药 -->
		<qDetails ref="details1"></qDetails>
		<!-- // 处方药 -->
		<qDetails2 ref="details2"></qDetails2>
		
		
		
		<!-- 正在进行医保交易 -->
		<q-pop-yibao v-if="yibaoShow" @click-enter="clickEnter"></q-pop-yibao>
		<!-- 请选择读取信息方式 -->
		<q-pop-read-card v-if="readCard" @click-enter="clickEnter2"></q-pop-read-card>

		<!-- 5个读卡的提示弹出框 -->
		<q-pop-read-tips v-if="readTipsShow" :numTips="readIndex" @tips-close="tipsClose"></q-pop-read-tips>
		
		
		<!-- 社保支付成功 -->
		<q-pop-success  @enter-click="ok" v-if="succressTips"></q-pop-success>
	</div>
</template>

<script>
	import qHead from '@/components/q-head/q-head.vue';
	import qBanner from '@/components/q-head/q-banner.vue';
	import qTitle from '@/components/q-read/q-title.vue';
	import qStep from '@/components/q-read/q-step.vue';
	// 西药
	import qDetails from '@/components/q-details/q-details.vue';
	// 处方药
	import qDetails2 from '@/components/q-details/q-details2.vue';
	
	
	
	//医保交易
	import qPopYibao from '@/components/q-pop/q-pop-yibao.vue';
	//交易成功提示
	import qPopSuccess from '@/components/q-pop/q-pop-success.vue';
	
	
	//选择 医保读卡
	import qPopReadCard from '@/components/q-pop/q-pop-read-card.vue';
	//读卡提示
	import qPopReadTips from '@/components/q-pop/q-pop-read-tips.vue';
	
	export default {
		components: {
			qHead,qBanner,qStep,qTitle,qDetails,qDetails2,qPopYibao,qPopReadCard,qPopReadTips,qPopSuccess
		},
		data() {
			return {
				yibaoShow:false,
				readCard:false,
				readTipsShow:false,
				succressTips:false,
				readIndex:null
			}
		},
		mounted() {
			
		},
		methods:{
			look1(){
				this.$refs.details1.show=true
			},
			look2(){
				this.$refs.details2.show=true
			},
			
			useYibao(){
				var that=this;
				that.yibaoShow=false
				that.readTipsShow=false
				//请选择读取信息方式
				that.readCard=true
				
			},
			
			clickEnter(data){
				var that=this;
				//正在进行医保交易 的返回
				this.yibaoShow=false
				
				// 交易成功.弹出 弹出框
				setTimeout(()=>{
					that.succressTips=true
				},100)
				//this.readCard=true
			},
			clickEnter2(data){
				var that=this
				// 请选择读取信息方式
				this.readCard=false
				//返回 1 医保 ，4 社保
				this.readIndex=data
				
				//提示插卡
				this.readTipsShow=true
				
				
				// 模拟 等待4秒插卡成功
				setTimeout(()=>{
					//关闭插卡提示
					that.readTipsShow=false
					//插卡后 提示交易中
					that.yibaoShow = true
				},3000)
				
			},
			ok(){
				this.succressTips=false
				this.openUrl("/")
			},
			tipsClose(data){
				this.readTipsShow=false
			}
		},
		beforeDestroy() {
			//clearInterval(this.timer);
		}
		
	}
</script>

<style scoped lang="less">
	
</style>
